import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PreviewCompatibleImage from '../../components/preview-compatible-image';
import isBrowser from '../../helpers/isBrowser';

const locale = isBrowser() ? (navigator.language || navigator.userLanguage) : 'nl-NL';
const formatter = new Intl.NumberFormat(locale, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

function ScreenshotToGif({
  className, image, timing, showClip, id, updateReady, imageBackgroundColor, inline,
}) {
  const [size, updateSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    function getSizes() {
      const img = document.getElementById(id);
      if (img.clientWidth > 75 && img.clientHeight > 125) {
        updateSize({ width: img.clientWidth - 8, height: img.clientHeight - 8 });
        updateReady(true);
      } else {
        // eslint-disable-next-line no-use-before-define
        scheduleGetSizes();
      }
    }

    function scheduleGetSizes() {
      setTimeout(getSizes, 250);
    }

    scheduleGetSizes();
  }, [showClip, id, updateReady]);

  return (
    <Wrapper className={className}>
      <HeroImage
        imageBackgroundColor={imageBackgroundColor}
        id={id}
        image={image}
        showClip={showClip}
        style={showClip && size}
      />
      {
        showClip && (
        <TimeCounterWrapper inline={inline}>
          <TimeCounter>
            {formatter.format(timing / 1000)} sec
          </TimeCounter>
        </TimeCounterWrapper>
        )
      }
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: inline-block;
  position: relative;
  max-height: 250px;
`;

const HeroImage = styled(PreviewCompatibleImage)`
  max-width: 100%;
  max-height: inherit;
  background: ${(props) => props.imageBackgroundColor || 'linear-gradient(to right,rgb(242 245 246),rgb(242 245 246))'};
  padding: ${(props) => (props.imageBackgroundColor ? 6 : 4)}px;
  ${(props) => {
    if (props.showClip && props.style.width > 8) {
      return `
        width: ${props.style.width}px;
        height: ${props.style.height}px;
      `;
    }
    return null;
  }}
  
`;

const TimeCounterWrapper = styled.div`
  ${(props) => {
    if (props.inline) {
      return `
        right: 0;
        bottom: 1rem;
      `;
    }
    return `
        left: 4px;
        bottom: 0;
      `;
  }}
  position: absolute;
  text-align: right;
`;

const TimeCounter = styled.span`
  color: ${(props) => props.theme.primaryColor};
  background: rgba(255,255,255,0.7);
  padding: 2px 4px;
  width: calc(50% - 4px);
`;

export default ScreenshotToGif;
